import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "stage", "side", "date", "reply", "withDate", "dateView", "offset", "isLoading", "author", "children", "withUsername", "additionalControls", "bordered", "zoneType", "withBackground", "message"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { forwardRef, useEffect, useRef } from 'react';
import { Text } from '@carnica/ui-kit';
import { useInView } from 'framer-motion';
import { combineRefs } from '@carnica/utils';
import { cnBem, getMessageFile, isFileMessage } from "../../../../shared/lib";
import { Loader } from "../../../../shared/ui";
import { useAppDispatch } from "../../../../shared/model";
import { AttachLabel } from "../../../../shared/config";
import { ymPushRefreshAttach } from "../../../../shared/analytics";
import { useReplyMessage } from "../../lib/hooks";
import { MessagePropStage } from "../../types";
import { setWindowBlocked } from "../../../settings/model";
import { getImageThunk, setContext } from "../../model";
import { useUnreadedMessagesContext } from "../../model/context";
import { MessageStatus, MessageType } from "../../../../shared/api";
import { RefreshButton } from "../../../../features/refresh-button/ui";
import styles from "./styles.pcss";
import { DateBlock } from "../DateBlock";
import { Reply } from "../Reply";
import { ReloadIndicator } from "../ReloadIndicator";
var cnWrapper = cnBem('wrapper', styles);
export var Wrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    _props$stage = props.stage,
    stage = _props$stage === void 0 ? MessagePropStage.UNKNOWN : _props$stage,
    _props$side = props.side,
    side = _props$side === void 0 ? 'opposite' : _props$side,
    date = props.date,
    reply = props.reply,
    _props$withDate = props.withDate,
    withDate = _props$withDate === void 0 ? true : _props$withDate,
    _props$dateView = props.dateView,
    dateView = _props$dateView === void 0 ? 'inside' : _props$dateView,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 'small' : _props$offset,
    isLoading = props.isLoading,
    author = props.author,
    children = props.children,
    withUsername = props.withUsername,
    additionalControls = props.additionalControls,
    _props$bordered = props.bordered,
    bordered = _props$bordered === void 0 ? true : _props$bordered,
    zoneType = props.zoneType,
    _props$withBackground = props.withBackground,
    withBackground = _props$withBackground === void 0 ? true : _props$withBackground,
    message = props.message,
    otherProps = _objectWithoutProperties(props, _excluded);
  var messageRef = useRef(null);
  var wrapperRef = useRef(null);
  var isInView = useInView(wrapperRef);
  var onInView = useUnreadedMessagesContext();
  useEffect(function () {
    if (isInView) {
      onInView(message.messageId);
    }
  }, [isInView]);
  var onReplyClick = useReplyMessage(reply);
  var dispatch = useAppDispatch();
  var openContext = function openContext() {
    dispatch(setWindowBlocked(true));
    dispatch(setContext({
      id: message.messageId,
      reason: 'menu'
    }));
  };
  var handleRightClick = function handleRightClick(e) {
    if (isFileMessage(message.message.type)) {
      return;
    }
    e.preventDefault();
    openContext();
  };
  var handleRefreshClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getMessageFile, fileUrl, label;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getMessageFile = getMessageFile(message), fileUrl = _getMessageFile.fileUrl;
            if (!fileUrl) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return dispatch(getImageThunk({
              url: fileUrl,
              message: message
            }));
          case 4:
            label = message.message.type === MessageType.Img ? AttachLabel.IMAGE : AttachLabel.FIlE;
            ymPushRefreshAttach(label);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleRefreshClick() {
      return _ref.apply(this, arguments);
    };
  }();
  var onKeyDown = function onKeyDown(e) {
    if (e.code === 'Enter' || e.code === 'Space') {
      e.stopPropagation();
      e.preventDefault();
      openContext();
    }
  };
  var isUsernameVisible = side === 'opposite' && message.message.type !== MessageType.CAPTCHA && withUsername && !!(author !== null && author !== void 0 && author.name);
  var showRefreshButton = message.messageStatus === MessageStatus.refresh && isFileMessage(message.message.type);
  return /*#__PURE__*/React.createElement("div", {
    className: cnWrapper({
      side: side
    }),
    ref: combineRefs([ref, wrapperRef])
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: cnWrapper('content', {
      offset: offset,
      side: side,
      bordered: bordered,
      filled: withBackground,
      isLoading: isLoading
    }, [className]),
    onContextMenu: handleRightClick,
    onKeyDown: onKeyDown,
    ref: messageRef
  }, otherProps), isUsernameVisible && /*#__PURE__*/React.createElement(Text, {
    className: cnWrapper('username'),
    color: "tertiary",
    variant: "caption-medium"
  }, author.name), isLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, reply && /*#__PURE__*/React.createElement(Reply, {
    className: cnWrapper('reply'),
    onReplyClick: onReplyClick,
    reply: reply,
    side: side
  }), children, stage !== MessagePropStage.REJECTED && withDate && /*#__PURE__*/React.createElement(DateBlock, {
    className: cnWrapper('date', {
      view: dateView
    }),
    date: date,
    side: side,
    stage: stage,
    view: dateView
  }))), additionalControls, stage === MessagePropStage.REJECTED && message.messageStatus !== MessageStatus.refresh && /*#__PURE__*/React.createElement(ReloadIndicator, {
    className: cnWrapper('indicator'),
    messageId: message.messageId,
    zoneType: zoneType
  }), showRefreshButton && /*#__PURE__*/React.createElement(RefreshButton, {
    buttonLabel: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443 \u0444\u0430\u0439\u043B\u0430",
    onClick: handleRefreshClick
  }));
});